import { render, staticRenderFns } from "./GoodsServicesSelect.vue?vue&type=template&id=55fceb44&scoped=true&"
import script from "./GoodsServicesSelect.vue?vue&type=script&lang=js&"
export * from "./GoodsServicesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fceb44",
  null
  
)

export default component.exports